import {Button, Col, Modal, Row} from "react-bootstrap";
import styles from "./Notes.module.css";

export const DeleteNoteFileConfirmationModal = (props: {onYes: Function, onCancel: Function, show: boolean}) => {
    return (
        <Modal
            show={props.show}
            size="sm"
            centered
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>Delete file?</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <Row>
                    <Col xs={2}>
                        <Button variant="danger" onClick={async () => {await props.onYes();}}>Yes</Button>
                    </Col>
                    <Col className={styles.right} xs={10}>
                        <Button variant="secondary" onClick={() => props.onCancel()}>Cancel</Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}
